import { Grid } from '@mui/material';
import BasePriceButtons from './BasePriceButtons';
import BasePriceTable from './BasePriceTable';

export const BasePrice = () => (
    <Grid container spacing={1}>
        <Grid item xs={12}>
            <BasePriceButtons />
        </Grid>
        <Grid item xs={12} style={{ height: '82vh' }}>
            <BasePriceTable />
        </Grid>
    </Grid>
);
